import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";

// Mirrors SendAsAddress in the backend (src/sendAs.ts)
export interface SendAsAddress {
    email: string;
    user: string;
    domain: string;
    displayName: string;
    kind: "self" | "user" | "group";
}

export interface SendAsState {
    addresses: SendAsAddress[];
    loaded: boolean;
}

const initialState: SendAsState = {
    addresses: [],
    loaded: false
};

export const sendAsSlice = createSlice({
    name: 'sendAs',
    initialState,
    reducers: {
        setSendAsAddresses: (state, action: PayloadAction<SendAsAddress[]>) => {
            state.addresses = action.payload;
            state.loaded = true;
        }
    }
});

export const { setSendAsAddresses } = sendAsSlice.actions;

export const sendAsAddresses = (state: RootState) => state.sendAs.addresses;

// The string that goes in the From field / request body. The backend parses
// "Name <email>" as well as a bare address; only add the name when it is
// something more useful than the local part.
export function formatSendAsAddress(address: SendAsAddress): string {
    if (address.displayName && address.displayName !== address.user) {
        return address.displayName + " <" + address.email + ">";
    }
    return address.email;
}

export default sendAsSlice.reducer;
